import { render, staticRenderFns } from "./search-dv.vue?vue&type=template&id=12f4afa1&scoped=true&"
import script from "./search-dv.vue?vue&type=script&lang=js&"
export * from "./search-dv.vue?vue&type=script&lang=js&"
import style0 from "./search-dv.vue?vue&type=style&index=0&id=12f4afa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4afa1",
  null
  
)

export default component.exports